export default __webpack_public_path__ + "static/media/MatchingGame.82f4b705.mov";